module.exports = __webpack_public_path__ + "build/img/qua_s.b3345c20.png";